import {cs}             from "@Common/react/chain-services";
import {consumeContext} from "@Common/react/context";

export const BlockGuestAccess = ({next}) => cs(
    consumeContext("session"),
    consumeContext("userLevels"),
    ({session, userLevels}) => next(session.data?.branch?.isGuestBranch || userLevels?.isGuest),
);